import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'facturaCheckbox'
})
export class FacturaCheckboxPipe implements PipeTransform {

  transform(value: string): any {
    if(value == null){
      value = "0";
    }
    return value;
  }

}
